import clsx from "classnames";
import { Col, Container, Row } from "react-bootstrap";
import PropTypes from "prop-types";
import { useState } from "react";
import classes from "./styles.module.scss";
import { CollapsibleSectionItem, Description, Title } from "@/ui";

export const CollapsibleSection = ({ className, bgColor, textColor, title, titleColor, description, items, md }) => {
  const [active, setActive] = useState();

  if (
    items
      .map((i) => i.title)
      .join("")
      .trim().length === 0
  ) {
    return null;
  }

  return (
    <div className={clsx(className, bgColor, textColor, classes.collapsible)}>
      <Container className="mw-xxl">
        <Title className={titleColor} title={title} />
        <Description description={description} />
        <div className={classes.collapsible__items}>
          {items.map(({ title, body }, k) => (
            <CollapsibleSectionItem
              key={k}
              title={title}
              body={body}
              active={k === active}
              onClick={() => setActive(k === active ? null : k)}
            />
          ))}
        </div>
      </Container>
    </div>
  );
};

export default CollapsibleSection;
